import styled from "styled-components";

export const Button = styled.button`
    min-width: 15em;
    padding: 0.5em 0.75em;
    font-size: 1em;
    color: #282828;
    background-color: #ffffff;
    border: 1px solid #282828;
    border-radius: 0;
    cursor: pointer;

    &:hover {
        background-color: #d7d7d7;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1em;
    padding-top: 2em;
`;

export const SaveButton = styled.button`
    min-width: 15em;
    align-self: center;
    padding: 0.5em 0.75em;
    font-size: 1em;
    color: #ffffff;
    background-color: #f10000;
    border: none;
    border-radius: 0;
    cursor: pointer;

    &:hover {
        background-color: #de0000;
    }

    &:disabled {
        background-color: rgba(241, 0, 0, 0.7);
        color: rgba(255, 255, 255, 0.7);
        cursor: not-allowed;
    }
`;

export const AuthButton = styled.button`
    min-width: 15em;
    padding: 0.5em 0.75em;
    font-size: 1em;
    color: #fff;
    background-color: #1e1e1e;
    border: none;
    border-radius: 0;
    cursor: pointer;

    &:hover {
        background-color: #282828;
    }
`;

export const Form = styled.form`
    display: flex;
    padding: 0.25rem 1.25rem 0.25rem 0.25rem;
    flex-direction: column;
    align-items: stretch;
    scroll-behavior: smooth;
    overflow: hidden;
    overflow-y: scroll;
    margin-bottom: 1.25em;
`;

export const AuthForm = styled.form`
    display: flex;
    padding: 0.25rem 0.25rem 0.25rem 0.25rem;
    flex-direction: column;
    align-items: stretch;
    scroll-behavior: smooth;
    overflow: hidden;
    margin-bottom: 1.25em;
`;

export const FormContainer = styled.div`
    max-height: 80svh;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 1em 0.25rem 1em 1.5em;
    background-color: whitesmoke;
`;

export const AuthContainer = styled.div`
    display: flex;
    align-self: center;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    padding: 2em 1em 2em 1em;
`;

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.75em;
    margin-bottom: .5rem;
`;

export const FormGroupContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 0.5em;
`;

export const Figure = styled.figure`
    width: 5rem;
    margin: 0;
`;

export const Figcaption = styled.figcaption`
    font-size: 0.5rem;
    text-overflow: ellipsis fade;
    overflow: hidden;
    white-space: nowrap;
`;

export const Input = styled.input`
    padding: 0.5em 0.75em;
    font-size: 1em;
    border: 1px solid #ccc;
    border-radius: 0;
    margin-bottom: 1em;
`;

export const TextInput = styled.textarea`
    min-height: 15em;
    padding: 0.5em 0.75em;
    font-size: 1em;
    border: 1px solid #ccc;
    border-radius: 0;
    resize: none;
    font-family: inherit;
`;

export const Label = styled.label`
    font-size: 0.75em;
    font-weight: bold;
    color: #9e9e9e;
`;

export const Select = styled.select`
    padding: 0.5em 0.75em;
    font-size: 1em;
    border: 1px solid #ccc;
    border-radius: 0;
    margin-bottom: 1em;
`;

export const MagazineSelect = styled(Select)`
    margin-bottom: 0.25em;
    height: 100%;
`;

export const Thumbnail = styled.img`
    height: 5rem;
    width: 5rem;
`;

export const UploadButton = styled.button`
    display: flex;
    flex-direction: row;
    gap: 0.25em;
    justify-content: center;
    align-items: center;
    max-width: 15em;
    padding: 0.5em 0.75em;
    font-size: 1em;
    color: #ffffff;
    background-color: rgba(241, 0, 0, 0.7);
    border: 1px solid #282828;
    border-radius: 0;
    cursor: pointer;

    &:hover {
        background-color: #f10000;
    }
`;

export const UploadIcon = styled.img`
    height: 1.5em;
    width: 1.5em;
`;

export const UploadInput = styled.input`
    width: 100%;
    padding: 0.5em 0.75em;
    font-size: 1em;
    border: 1px solid #ccc;
    border-radius: 0;
`;

export const UploadWrap = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1em;
`;
